import React from 'react';
import { HintCellWrapper, HintTagWrapper, StyledTag } from './styled';
import { Tag, Tooltip } from 'antd';

export const hintColorMap = {
  Outlier: 'blue',
  'Worse in Impacted': 'cyan',
};

const HintTag = ({ tag }) => {
  const color = hintColorMap[tag?.label];
  if (!tag.reason || !tag.label) {
    return <div />;
  }
  return (
    <Tooltip title={tag.reason} placement="topRight">
      <StyledTag color={color}>{tag.label}</StyledTag>
    </Tooltip>
  );
};

const HintCell = ({ cellData }) => {
  cellData.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  return (
    <HintCellWrapper>
      {cellData.map((tag) => (
        <HintTag key={`${tag.label}/${tag.reason}`} tag={tag} />
      ))}
    </HintCellWrapper>
  );
};

export default HintCell;
